import React from 'react'
import hobbies from '../../data/hobbies'
import Block from '../Block'
import {
  HobbiesWrapper,
  HobbiesTitleWrapper,
  HobbiesUlWrapper,
  HobbiesLiWrapper,
  HobbiesTitle,
} from './Hobbies.styles'
import Icon from '../Icon'

const Hobbies = () => {
  return (
    <Block>
      <HobbiesWrapper>
        <HobbiesTitleWrapper>
          <Icon icon="heart" />
          <HobbiesTitle>Hobbies</HobbiesTitle>
        </HobbiesTitleWrapper>
        <HobbiesUlWrapper>
          {hobbies.map((hobbie, i) => (
            <HobbiesLiWrapper key={i}>
              <Icon icon={hobbie.icon} />
              <HobbiesTitle>{hobbie.name}</HobbiesTitle>
            </HobbiesLiWrapper>
          ))}
        </HobbiesUlWrapper>
      </HobbiesWrapper>
    </Block>
  )
}

export default Hobbies
